/**
 * Cookie utility to replace redux-effects-cookie
 * Returns a thunk action that can be dispatched
 */

// Get a cookie value
const getCookie = (name) => {
  if (typeof document === 'undefined') return undefined
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return undefined
}

// Set a cookie value
const setCookie = (name, value, options = {}) => {
  if (typeof document === 'undefined') return

  let cookieString = `${name}=${value}`

  if (options.maxage) {
    const date = new Date()
    date.setTime(date.getTime() + options.maxage)
    cookieString += `; expires=${date.toUTCString()}`
  }

  if (options.path) cookieString += `; path=${options.path}`

  document.cookie = cookieString
}

// Delete a cookie
const deleteCookie = (name, options = {}) => {
  if (typeof document === 'undefined') return
  let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT`
  if (options.path) cookieString += `; path=${options.path}`
  document.cookie = cookieString
}

/**
 * Cookie action creator (thunk)
 * @param {string} name - Cookie name
 * @param {*} value - Optional value to set (undefined = read, null = delete)
 * @param {object} options - Cookie options (maxage, path)
 * @returns {function} Thunk that returns a promise
 */
export const cookie = (name, value, options = {}) => () =>
  new Promise((resolve) => {
    if (value === undefined)
      // Read cookie
      resolve(getCookie(name))
    else if (value === null) {
      // Delete cookie
      deleteCookie(name, options)
      resolve()
    } else {
      // Set cookie
      setCookie(name, value, options)
      resolve()
    }
  })

export default cookie
